/**
 * @generated SignedSource<<3ba33e180080d452e5b735fdf649b3f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SellerApplicationFormInventorySample_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SellerApplicationFormInventorySampleModal_viewer">;
  readonly " $fragmentType": "SellerApplicationFormInventorySample_viewer";
};
export type SellerApplicationFormInventorySample_viewer$key = {
  readonly " $data"?: SellerApplicationFormInventorySample_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SellerApplicationFormInventorySample_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SellerApplicationFormInventorySample_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SellerApplicationFormInventorySampleModal_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "497dd8e3ab36c5a92b4d823cdd623ea2";

export default node;
